"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countries = void 0;
var countries = [{
  "nationality": "Française",
  "name": "France",
  "alpha-2": "FR",
  "alpha-3": "FRA",
  "country-code": "250"
}, {
  "nationality": "Andorrane",
  "name": "Andorre",
  "alpha-2": "AD",
  "alpha-3": "AND",
  "country-code": "20"
}, {
  "nationality": "Autrichienne",
  "name": "Autriche",
  "alpha-2": "AT",
  "alpha-3": "AUT",
  "country-code": "40"
}, {
  "nationality": "Belge",
  "name": "Belgique",
  "alpha-2": "BE",
  "alpha-3": "BEL",
  "country-code": "56"
}, {
  "nationality": "Bulgare",
  "name": "Bulgarie",
  "alpha-2": "BG",
  "alpha-3": "BGR",
  "country-code": "100"
}, {
  "nationality": "Chypriote",
  "name": "Chypre",
  "alpha-2": "CY",
  "alpha-3": "CYP",
  "country-code": "196"
}, {
  "nationality": "Croate",
  "name": "Croatie",
  "alpha-2": "HR",
  "alpha-3": "HRV",
  "country-code": "191"
}, {
  "nationality": "Tcheque",
  "name": "République Tchèque",
  "alpha-2": "CZ",
  "alpha-3": "CZE",
  "country-code": "203"
}, {
  "nationality": "Danoise",
  "name": "Danemark",
  "alpha-2": "DK",
  "alpha-3": "DNK",
  "country-code": "208"
}, {
  "nationality": "Estonienne",
  "name": "Estonie",
  "alpha-2": "EE",
  "alpha-3": "EST",
  "country-code": "233"
}, {
  "nationality": "Finlandaise",
  "name": "Finlande",
  "alpha-2": "FI",
  "alpha-3": "FIN",
  "country-code": "246"
}, {
  "nationality": "Georgienne",
  "name": "Géorgie",
  "alpha-2": "GE",
  "alpha-3": "GEO",
  "country-code": "268"
}, {
  "nationality": "Allemande",
  "name": "Allemagne",
  "alpha-2": "DE",
  "alpha-3": "DEU",
  "country-code": "276"
}, {
  "nationality": "Hellenique",
  "name": "Grèce",
  "alpha-2": "GR",
  "alpha-3": "GRC",
  "country-code": "300"
}, {
  "nationality": "Hongroise",
  "name": "Hongrie",
  "alpha-2": "HU",
  "alpha-3": "HUN",
  "country-code": "348"
}, {
  "nationality": "Irlandaise",
  "name": "Irlande",
  "alpha-2": "IE",
  "alpha-3": "IRL",
  "country-code": "372"
}, {
  "nationality": "Islandaise",
  "name": "Islande",
  "alpha-2": "IS",
  "alpha-3": "ISL",
  "country-code": "352"
}, {
  "nationality": "Italienne",
  "name": "Italie",
  "alpha-2": "IT",
  "alpha-3": "ITA",
  "country-code": "380"
}, {
  "nationality": "Lettone",
  "name": "Lettonie",
  "alpha-2": "LV",
  "alpha-3": "LVA",
  "country-code": "428"
}, {
  "nationality": "Liechtensteinoise",
  "name": "Liechtenstein",
  "alpha-2": "LI",
  "alpha-3": "LIE",
  "country-code": "438"
}, {
  "nationality": "Lituanienne",
  "name": "Lituanie",
  "alpha-2": "LT",
  "alpha-3": "LTU",
  "country-code": "440"
}, {
  "nationality": "Luxembourgeoise",
  "name": "Luxembourg",
  "alpha-2": "LU",
  "alpha-3": "LUX",
  "country-code": "442"
}, {
  "nationality": "Macedonienne",
  "name": "L'ex-République Yougoslave de Macédoine",
  "alpha-2": "MK",
  "alpha-3": "MKD",
  "country-code": "807"
}, {
  "nationality": "Maltaise",
  "name": "Malte",
  "alpha-2": "MT",
  "alpha-3": "MLT",
  "country-code": "470"
}, {
  "nationality": "Monegasque",
  "name": "Monaco",
  "alpha-2": "MC",
  "alpha-3": "MCO",
  "country-code": "492"
}, {
  "nationality": "Moldave",
  "name": "République de Moldova",
  "alpha-2": "MD",
  "alpha-3": "MDA",
  "country-code": "498"
}, {
  "nationality": "Neerlandaise",
  "name": "Pays-Bas",
  "alpha-2": "NL",
  "alpha-3": "NLD",
  "country-code": "528"
}, {
  "nationality": "Norvegienne",
  "name": "Norvège",
  "alpha-2": "NO",
  "alpha-3": "NOR",
  "country-code": "578"
}, {
  "nationality": "Polonaise",
  "name": "Pologne",
  "alpha-2": "PL",
  "alpha-3": "POL",
  "country-code": "616"
}, {
  "nationality": "Portugaise",
  "name": "Portugal",
  "alpha-2": "PT",
  "alpha-3": "PRT",
  "country-code": "620"
}, {
  "nationality": "Roumaine",
  "name": "Roumanie",
  "alpha-2": "RO",
  "alpha-3": "ROU",
  "country-code": "642"
}, {
  "nationality": "Saint-Marinaise",
  "name": "Saint-Marin",
  "alpha-2": "SM",
  "alpha-3": "SMR",
  "country-code": "674"
}, {
  "nationality": "Slovaque",
  "name": "Slovaquie",
  "alpha-2": "SK",
  "alpha-3": "SVK",
  "country-code": "703"
}, {
  "nationality": "Slovene",
  "name": "Slovénie",
  "alpha-2": "SI",
  "alpha-3": "SVN",
  "country-code": "705"
}, {
  "nationality": "Espagnole",
  "name": "Espagne",
  "alpha-2": "ES",
  "alpha-3": "ESP",
  "country-code": "724"
}, {
  "nationality": "Suedoise",
  "name": "Suède",
  "alpha-2": "SE",
  "alpha-3": "SWE",
  "country-code": "752"
}, {
  "nationality": "Suisse",
  "name": "Suisse",
  "alpha-2": "CH",
  "alpha-3": "CHE",
  "country-code": "756"
}, {
  "nationality": "Turque",
  "name": "Turquie",
  "alpha-2": "TR",
  "alpha-3": "TUR",
  "country-code": "792"
}, {
  "nationality": "Britannique",
  "name": "Royaume-Uni",
  "alpha-2": "GB",
  "alpha-3": "GBR",
  "country-code": "826"
}, {
  "nationality": "Beninoise",
  "name": "Bénin",
  "alpha-2": "BJ",
  "alpha-3": "BEN",
  "country-code": "204"
}, {
  "nationality": "Burkinabe",
  "name": "Burkina Faso",
  "alpha-2": "BF",
  "alpha-3": "BFA",
  "country-code": "854"
}, {
  "nationality": "Camerounaise",
  "name": "Cameroun",
  "alpha-2": "CM",
  "alpha-3": "CMR",
  "country-code": "120"
}, {
  "nationality": "Cap-verdienne",
  "name": "Cap-vert",
  "alpha-2": "CV",
  "alpha-3": "CPV",
  "country-code": "132"
}, {
  "nationality": "Comorienne",
  "name": "Comores",
  "alpha-2": "KM",
  "alpha-3": "COM",
  "country-code": "174"
}, {
  "nationality": "Djiboutienne",
  "name": "Djibouti",
  "alpha-2": "DJ",
  "alpha-3": "DJI",
  "country-code": "262"
}, {
  "nationality": "Kenyane",
  "name": "Kenya",
  "alpha-2": "KE",
  "alpha-3": "KEN",
  "country-code": "404"
}, {
  "nationality": "Lesothane",
  "name": "Lesotho",
  "alpha-2": "LS",
  "alpha-3": "LSO",
  "country-code": "426"
}, {
  "nationality": "Malgache",
  "name": "Madagascar",
  "alpha-2": "MG",
  "alpha-3": "MDG",
  "country-code": "450"
}, {
  "nationality": "Malawienne",
  "name": "Malawi",
  "alpha-2": "MW",
  "alpha-3": "MWI",
  "country-code": "454"
}, {
  "nationality": "Mauricienne",
  "name": "Maurice",
  "alpha-2": "MU",
  "alpha-3": "MUS",
  "country-code": "480"
}, {
  "nationality": "Marocaine",
  "name": "Maroc",
  "alpha-2": "MA",
  "alpha-3": "MAR",
  "country-code": "504"
}, {
  "nationality": "Rwandaise",
  "name": "Rwanda",
  "alpha-2": "RW",
  "alpha-3": "RWA",
  "country-code": "646"
}, {
  "nationality": "Senegalaise",
  "name": "Sénégal",
  "alpha-2": "SN",
  "alpha-3": "SEN",
  "country-code": "686"
}, {
  "nationality": "Sud-africaine",
  "name": "Afrique du Sud",
  "alpha-2": "ZA",
  "alpha-3": "ZAF",
  "country-code": "710"
}, {
  "nationality": "Surinamaise",
  "name": "Suriname",
  "alpha-2": "SR",
  "alpha-3": "SUR",
  "country-code": "740"
}, {
  "nationality": "Swazie",
  "name": "Swaziland",
  "alpha-2": "SZ",
  "alpha-3": "SWZ",
  "country-code": "748"
}, {
  "nationality": "Tanzanienne",
  "name": "République-Unie de Tanzanie",
  "alpha-2": "TZ",
  "alpha-3": "TZA",
  "country-code": "834"
}, {
  "nationality": "Tonguienne",
  "name": "Togo",
  "alpha-2": "TG",
  "alpha-3": "TGO",
  "country-code": "768"
}, {
  "nationality": "Argentine",
  "name": "Argentine",
  "alpha-2": "AR",
  "alpha-3": "ARG",
  "country-code": "32"
}, {
  "nationality": "Bresilienne",
  "name": "Brésil",
  "alpha-2": "BR",
  "alpha-3": "BRA",
  "country-code": "76"
}, {
  "nationality": "Canadienne",
  "name": "Canada",
  "alpha-2": "CA",
  "alpha-3": "CAN",
  "country-code": "124"
}, {
  "nationality": "Chilienne",
  "name": "Chili",
  "alpha-2": "CL",
  "alpha-3": "CHL",
  "country-code": "152"
}, {
  "nationality": "Costaricaine",
  "name": "Costa Rica",
  "alpha-2": "CR",
  "alpha-3": "CRI",
  "country-code": "188"
}, {
  "nationality": "Dominiquaise",
  "name": "Dominique",
  "alpha-2": "DM",
  "alpha-3": "DMA",
  "country-code": "212"
}, {
  "nationality": "Dominicaine",
  "name": "République Dominicaine",
  "alpha-2": "DO",
  "alpha-3": "DOM",
  "country-code": "214"
}, {
  "nationality": "Hondurienne",
  "name": "Honduras",
  "alpha-2": "HN",
  "alpha-3": "HND",
  "country-code": "340"
}, {
  "nationality": "Jamaïcaine",
  "name": "Jamaïque",
  "alpha-2": "JM",
  "alpha-3": "JAM",
  "country-code": "388"
}, {
  "nationality": "Mexicaine",
  "name": "Mexique",
  "alpha-2": "MX",
  "alpha-3": "MEX",
  "country-code": "484"
}, {
  "nationality": "Paraguayenne",
  "name": "Paraguay",
  "alpha-2": "PY",
  "alpha-3": "PRY",
  "country-code": "600"
}, {
  "nationality": "Peruvienne",
  "name": "Pérou",
  "alpha-2": "PE",
  "alpha-3": "PER",
  "country-code": "604"
}, {
  "nationality": "Portoricaine",
  "name": "Porto Rico",
  "alpha-2": "PR",
  "alpha-3": "PRI",
  "country-code": "630"
}, {
  "nationality": "Salvadorienne",
  "name": "El Salvador",
  "alpha-2": "SV",
  "alpha-3": "SLV",
  "country-code": "222"
}, {
  "nationality": "Americaine",
  "name": "États-Unis",
  "alpha-2": "US",
  "alpha-3": "USA",
  "country-code": "840"
}, {
  "nationality": "Uruguayenne",
  "name": "Uruguay",
  "alpha-2": "UY",
  "alpha-3": "URY",
  "country-code": "858"
}, {
  "nationality": "Bhoutanaise",
  "name": "Bhoutan",
  "alpha-2": "BT",
  "alpha-3": "BTN",
  "country-code": "64"
}, {
  "nationality": "Chinoise",
  "name": "Chine",
  "alpha-2": "CN",
  "alpha-3": "CHN",
  "country-code": "156"
}, {
  "nationality": "Indienne",
  "name": "Inde",
  "alpha-2": "IN",
  "alpha-3": "IND",
  "country-code": "356"
}, {
  "nationality": "Japonaise",
  "name": "Japon",
  "alpha-2": "JP",
  "alpha-3": "JPN",
  "country-code": "392"
}, {
  "nationality": "Sud-coréenne",
  "name": "République de Corée",
  "alpha-2": "KR",
  "alpha-3": "KOR",
  "country-code": "410"
}, {
  "nationality": "Malaisienne",
  "name": "Malaisie",
  "alpha-2": "MY",
  "alpha-3": "MYS",
  "country-code": "458"
}, {
  "nationality": "Philippine",
  "name": "Philippines",
  "alpha-2": "PH",
  "alpha-3": "PHL",
  "country-code": "608"
}, {
  "nationality": "Singapourienne",
  "name": "Singapour",
  "alpha-2": "SG",
  "alpha-3": "SGP",
  "country-code": "702"
}, {
  "nationality": "Taiwanaise",
  "name": "Taïwan",
  "alpha-2": "TW",
  "alpha-3": "TWN",
  "country-code": "158"
}, {
  "nationality": "Thaïlandaise",
  "name": "Thaïlande",
  "alpha-2": "TH",
  "alpha-3": "THA",
  "country-code": "764"
}, {
  "nationality": "Vietnamienne",
  "name": "Viet Nam",
  "alpha-2": "VN",
  "alpha-3": "VNM",
  "country-code": "704"
}, {
  "nationality": "Australienne",
  "name": "Australie",
  "alpha-2": "AU",
  "alpha-3": "AUS",
  "country-code": "36"
}, {
  "nationality": "Fidjienne",
  "name": "Fidji",
  "alpha-2": "FJ",
  "alpha-3": "FJI",
  "country-code": "242"
}, {
  "nationality": "Kiribatienne",
  "name": "Kiribati",
  "alpha-2": "KI",
  "alpha-3": "KIR",
  "country-code": "296"
}, {
  "nationality": "Neo-zelandaise",
  "name": "Nouvelle-Zélande",
  "alpha-2": "NZ",
  "alpha-3": "NZL",
  "country-code": "554"
}, {
  "nationality": "Salomonaise",
  "name": "Îles Salomon",
  "alpha-2": "SB",
  "alpha-3": "SLB",
  "country-code": "90"
}, {
  "nationality": "Armenienne",
  "name": "Arménie",
  "alpha-2": "AM",
  "alpha-3": "ARM",
  "country-code": "51"
}, {
  "nationality": "Azerbaïdjanaise",
  "name": "Azerbaïdjan",
  "alpha-2": "AZ",
  "alpha-3": "AZE",
  "country-code": "31"
}, {
  "nationality": "Bahreinienne",
  "name": "Bahreïn",
  "alpha-2": "BH",
  "alpha-3": "BHR",
  "country-code": "48"
}, {
  "nationality": "Jordanienne",
  "name": "Jordanie",
  "alpha-2": "JO",
  "alpha-3": "JOR",
  "country-code": "400"
}, {
  "nationality": "Omanaise",
  "name": "Oman",
  "alpha-2": "OM",
  "alpha-3": "OMN",
  "country-code": "512"
}, {
  "nationality": "Qatarienne",
  "name": "Qatar",
  "alpha-2": "QA",
  "alpha-3": "QAT",
  "country-code": "634"
}, {
  "nationality": "Saoudienne",
  "name": "Arabie Saoudite",
  "alpha-2": "SA",
  "alpha-3": "SAU",
  "country-code": "682"
}, {
  "nationality": "Emirienne",
  "name": "Émirats Arabes Unis",
  "alpha-2": "AE",
  "alpha-3": "ARE",
  "country-code": "784"
}, {
  "nationality": "Guyanienne",
  "name": "Guyane Française",
  "alpha-2": "GF",
  "alpha-3": "GUF",
  "country-code": "254"
}];
exports.countries = countries;